import LogoDefault from "@/assets/regions/croydon-cgl-logo.png";
import { RiskLevel } from "@/model/RiskLevel";
const CroydonDefault = {
    rawCopy: "For alcohol advice and support in Croydon, call CGL on 0300 123 9288",
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/31"
};
export default {
    name: "Croydon",
    logo: {
        file: LogoDefault,
        width: 600,
        height: 190
    },
    hasFreeAppointments: true,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: CroydonDefault,
        [RiskLevel.Lower]: CroydonDefault,
        [RiskLevel.Increasing]: CroydonDefault,
        [RiskLevel.Higher]: CroydonDefault,
        [RiskLevel.High]: CroydonDefault
    },
    clinics: [
        {
            name: "Change Grow Live | Croydon",
            tagline: "Drug and Alcohol Service",
            address: "Lantern Hall, 190 Church Rd, Croydon, CR0 1SH",
            isPrimaryProvider: true,
            alwaysShowInResults: true,
            phone: ["0300 123 9288"],
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 1000, end: 1700 }],
                        tuesday: [{ start: 1000, end: 1700 }],
                        wednesday: [{ start: 1000, end: 1700 }],
                        thursday: [{ start: 1000, end: 1700 }],
                        friday: [{ start: 1000, end: 1700 }]
                    }
                }
            ],
            website: "https://changegrowlive.org/drug-alcohol-croydon",
            email: "croydon.info@cgl.org.uk",
            other_info: "For self referrals visit <a href='https://changegrowlive.org/drug-alcohol-croydon/referrals' target='_blank'>changegrowlive.org/drug-alcohol-croydon/referrals</a><br>" +
                "If you are under 25 please contact our <a href='https://www.changegrowlive.org/croydon-young-people/contact' target='_blank'>Young People's Team.</a>",
            location: {
                lat: 51.3687268,
                lng: -0.105391
            }
        }
    ]
};
//# sourceMappingURL=Croydon.js.map